import { FormikProps, getIn } from 'formik';

export const getFieldLabel = (name: string, isRequired: boolean) => {
  return isRequired ? `${name} *` : name;
};

/**
 * Formik getIn(obj, '') returns the whole object, not undefined.
 * FormItem must only surface leaf string errors — nested/array errors
 * belong on nested field names (e.g. primaryContacts.0.email).
 */
export const getFormikFieldError = (
  errors: FormikProps<unknown>['errors'],
  name?: string,
): string | undefined => {
  if (!name) {
    return undefined;
  }

  const error = getIn(errors, name, undefined);

  return typeof error === 'string' ? error : undefined;
};

export const getFormikFieldTouched = (
  touched: FormikProps<unknown>['touched'],
  name?: string,
): boolean => {
  if (!name) {
    return false;
  }

  return Boolean(getIn(touched, name, false));
};

export const clearFormError = (formik: FormikProps<any>, fieldName: string) => {
  if (!formik.getFieldMeta(fieldName).value) return;

  setTimeout(() => {
    formik.setFieldValue(fieldName, '');
  }, 0);
};
